export function MoneySourceType(data) {
    const {
        id,
        name: name,
        description: description,
        category_id: group,
    } = data;

    return {
        id,
        name: name || "",
        group: group || "null",
        description: description || "",
    };
}

export function formatMoneySourceType(data) {
    const { id, name, description, group } = data;

    const params = {
        name: name,
        category_id: group || "null",
        description: description,
    };

    if (id) params.id = id;

    return params;
}
